const mantutencao_parametros_comprovante_de_reserva = {
  path: "/manutencao-de-parametro-comprovante-reserva",
  redirect: "/manutencao-de-parametro-comprovante-reserva",
  meta: {
    breadCrumb: "Gerenciador de Parâmetro - Parâmetros de Atendimento",
  },
  children: [
    {
      path: "/manutencao-de-parametro-comprovante-reserva",
      name: "manutencao_de_parametro_comprovante_reserva",
      meta: {
        allowedPermissions: ["parametros_comprovante_rede_ensino_municipio"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeParametroComprovanteReserva/ManutencaoDeParametroComprovanteReserva.vue"
        ),
    },
    {
      path: "/manutencao-de-parametro-comprovante-reserva/:rede_ensino/:municipio?",
      name: "manutencao_de_parametro_comprovante_reserva_edit",
      meta: {
        allowedPermissions: ["parametros_comprovante_edit"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeParametroComprovanteReserva/ManutencaoDeParametroComprovanteReservaEdit.vue"
        ),
    },
    {
      path: "/manutencao-de-parametro-comprovante-reserva/novo/:rede_ensino/:municipio?",
      name: "manutencao_de_parametro_comprovante_reserva_cad",
      meta: {
        allowedPermissions: ["parametros_comprovante_create"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeParametroComprovanteReserva/ManutencaoDeParametroComprovanteReservaCad.vue"
        ),
    },
    {
      path: "/manutencao-de-parametro-comprovante-reserva/:parametros_comp_id/mensagem/novo",
      name: "manutencao_de_parametro_comprovante_reserva_mensagem_novo",
      meta: {
        allowedPermissions: ["mensagem_comprovante_create"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeParametroComprovanteReserva/ManutencaoDeMensagem/ManutencaoDeMensagemCad.vue"
        ),
    },
    {
      path: "/manutencao-de-parametro-comprovante-reserva/mensagem/:id",
      name: "manutencao_de_parametro_comprovante_reserva_mensagem_edit",
      meta: {
        allowedPermissions: ["mensagem_comprovante_edit"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeParametroComprovanteReserva/ManutencaoDeMensagem/ManutencaoDeMensagemEdit.vue"
        ),
    },
    {
      path: "/manutencao-de-parametro-comprovante-reserva/:parametros_comp_id/mensagem",
      name: "manutencao_de_parametro_comprovante_reserva_mensagem",
      meta: {
        allowedPermissions: ["mensagem_comprovante_index"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeParametroComprovanteReserva/ManutencaoDeMensagem/ManutencaoDeMensagem.vue"
        ),
    },
    {
      path: "/manutencao-de-parametro-comprovante-reserva/visualizar/:rede_ensino/:municipio?",
      name: "manutencao_de_parametro_comprovante_reserva_visualizar",
      meta: {
        allowedPermissions: ["parametros_comprovante_rede_ensino_municipio"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeParametroComprovanteReserva/ManutencaoDeParametroComprovanteReservaVisualizar.vue"
        ),
    },
  ],
};

export { mantutencao_parametros_comprovante_de_reserva };
